// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const corsola: PokeData = {
  "id": 222,
  "name": "corsola",
  "height": 6,
  "weight": 50,
  "base_experience": 144,
  "types": [
    PokeType.WATER,
    PokeType.ROCK
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "bubble-beam",
    "recover",
    "harden",
    "spike-cannon",
    "bubble",
    "flail",
    "endure",
    "mirror-coat",
    "ancient-power",
    "refresh",
    "iron-defense",
    "rock-blast",
    "brine",
    "lucky-chant",
    "aqua-ring",
    "power-gem",
    "earth-power",
    "life-dew"
  ],
  "moves": [
    "tackle",
    "bubble-beam",
    "bubble",
    "ancient-power",
    "refresh",
    "iron-defense",
    "rock-blast",
    "brine",
    "earth-power",
    "life-dew",
    "water-spout",
    "power-siphon",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 113,
    "item": null,
    "species": [
      {
        "name": "corsola",
        "order": 254,
        "types": [
          PokeType.WATER,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cursola",
        "order": 864,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 222,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 80,
    "speed": 35,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
